import { useParams } from "react-router";
import { useLocation } from "react-router";
import { useState } from "react";

import { useFetchClubsQuery } from "../../store/club/ClubApi";
import Grid from '@mui/material/Grid';
import { Box, CircularProgress } from "@mui/material";
import SubTitle from "./SubTitle";
import { Logo, dropZoneWidth } from "./Logo";
import TeamOverview from "./TeamOverview";
import { ClubStatus } from "./ClubStatus";
import { ClubUsers } from "./ClubUsers";
import TeamDetails from "./TeamDetails";
import { Snackbar, Alert } from '@mui/material';

export default function Club()
{  
  // Ermitteln der übergebenen Parameter
  let params = useParams();
  let clubLabel = params.clubLabel;
  let selectedYear = params.year;

  // Wir bekommen bei der Weiterleitung von einer anderen Quelle
  // (zum Beispiel von dem Anlegen eines neuen Teams) vielleicht
  // Informationen mitgeliefert. Diese sollten dann in location
  // stehen:
  const location = useLocation();
  const [successMessage, setSuccessMessage] = useState(location.state?.successMessage ?? '');

  // Einlesen der Clubs zum aktuellen Turnierjahr
  const {data:clubs, isLoading:clubsAreLoading} = useFetchClubsQuery(selectedYear);

  // Heraussuchen des aktuellen Clubs
  const selectedClub = (clubs && !clubsAreLoading)?clubs?.filter( element => element.label === clubLabel)[0]:null;

  // Ausgeben der Seite mit den Clubinfomationen
  if (clubsAreLoading||!selectedClub)
  {
    // Wir zeigen in der Mitte der Liste einfach ein Zeichen, dass
    // wir noch am Laden sind: 
    return(
      <CircularProgress />
    );
  }
  else
  {
    return (
      <>
        <Box sx={{ flexGrow: 1 }}>                  
          <SubTitle club={selectedClub} />
          <Box component="section" sx={{ padding:"20px" }}>
            <Grid container spacing={1}>
              <Grid size="grow">
                <ClubUsers year={selectedYear} club={selectedClub} />
              </Grid>
              <Grid size={2}>
                <ClubStatus year={selectedYear} club={selectedClub} />
              </Grid>
              <Grid style={{width: `${dropZoneWidth}px`}} >
                <Logo year={selectedYear} club={selectedClub} />
              </Grid>
              
              <Grid size={12}>
                <TeamOverview />
              </Grid>
              <TeamDetails selectedYear={selectedYear} selectedClub={selectedClub} />
              
            </Grid>
          </Box>          
        </Box>
        <Snackbar
          open={!!successMessage}
          autoHideDuration={4000}
          onClose={ () => setSuccessMessage('') }
          anchorOrigin={{ vertical : 'bottom', horizontal : 'center' }}
        >
          <Alert severity="success" onClose={ () => setSuccessMessage('')} variant="filled">
            {successMessage}
          </Alert>
        </Snackbar>
      </>
    );
  }
}